<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button></ion-back-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button (click)="openInformationModal()" class="header--button-close">
        <ion-icon name="information-circle"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{title}}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-grid>
    <ion-row>
      <ion-col>
        <form [formGroup]="siteEntryForm" (ngSubmit)="submitForm()">
          <ion-item lines="none">
            <ion-label class="auth-button-label" position="stacked">
              Provider site
            </ion-label>
            <ion-input #siteCodeInput type="text" formControlName="site" color="input-text"></ion-input>
            <control-label [control]="siteEntryForm.controls['site']" fieldName="Site code"></control-label>
          </ion-item>
        </form>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <list-card-item
            (click)="openSiteModal()"
            [isClickable]="true"
            title="Looking for your site code?"
            lines="full"
          >
          Already have a provider but don't know where your site code is?
        </list-card-item>
        <list-card-item
            title="Don't have a provider yet?"
            lines="full"
          >
          Visit our website to understand the programs available to you.
          <a href="javascript: void(0);" (click)="openProvidersPage()">View a list of providers</a>
        </list-card-item>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ion-footer class="auth-footer">
  <ion-grid>
    <ion-row>
      <ion-col>
        <ion-button expand="block" (click)="cancel()" class="auth-button secondary">Cancel</ion-button>
      </ion-col>
      <ion-col>
        <ion-button expand="block" (click)="submitForm()" [disabled]="!siteEntryForm.valid" class="auth-button primary">Register
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-footer>